var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "overlay" }, [
    _c("div", { staticClass: "overlay-body" }, [
      _c("h1", [
        _vm._v("先週一度も摂取していない食品群です。今週は摂取しましょう！！")
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "not-ingested-foods" },
        _vm._l(_vm.notIngestedFoods, function(foods) {
          return _c("div", [
            _c("p", { staticClass: "foods-name" }, [
              _vm._v("・" + _vm._s(foods.name))
            ])
          ])
        }),
        0
      ),
      _vm._v(" "),
      _c("div", { staticClass: "img-style" }, [
        _c("img", {
          attrs: { src: require("@/assets/アセット 9@2x.png") },
          on: { click: _vm.close }
        })
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-72a5cb94", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-72a5cb94","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NotIngestedAlert.vue
// module id = null
// module chunks = 